import { API, authHeaders, clearSession } from '../utils/auth.helpers';

async function apiFetch(path, options = {}) {
  const res = await fetch(API + path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) {
    const errData = await res.json().catch(() => null);
    const backendMsg =
      errData &&
      (Array.isArray(errData.message)
        ? errData.message.join(' · ')
        : errData.message || errData.error);

    if (path === '/auth/login') {
      throw new Error(backendMsg || 'Identifiants incorrects.');
    }

    clearSession();
    if (window.location.pathname !== '/login') window.location.href = '/login';
    throw new Error('Session expirée, reconnecte-toi.');
  }

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const msg =
      data &&
      (Array.isArray(data.message)
        ? data.message.join(' · ')
        : data.message || data.error);
    throw new Error(msg || `Erreur ${res.status}`);
  }
  return data;
}

export const api = {
  get: (p) => apiFetch(p),
  post: (p, body) => apiFetch(p, { method: 'POST', body: JSON.stringify(body) }),
  patch: (p, body) => apiFetch(p, { method: 'PATCH', body: JSON.stringify(body) }),
  del: (p) => apiFetch(p, { method: 'DELETE' }),
  put: (p, body) => apiFetch(p, { method: 'PUT', body: JSON.stringify(body) }),
};
